import { lazy } from 'react'
import RequireAuthentication from '@/router/guards/RequireAuthentication'
import { Route } from 'react-router-dom'

const FAQ = lazy(() => import('@/modules/StaticPages/pages/FAQ'))
const PrivacyPolicy = lazy(
  () => import('@/modules/StaticPages/pages/PrivacyPolicy'),
)

const StaticPagesRoutes = [
  <RequireAuthentication
    path="/duvidas"
    key="/duvidas"
    exact
    component={FAQ}
  />,
  <Route
    path="/politicas-de-privacidade"
    key="/politicas-de-privacidade"
    exact
    component={PrivacyPolicy}
  />,
]

export default StaticPagesRoutes
